<template>
  <vs-prompt
    buttons-hidden
    class="large"
    :title="data.id ? 'تعديل طالب' : 'إضافة طالب جديد'"
    @close="close"
    :active="active"
  >
    <h4 class="mb-3">قم بادخال بيانات الطالب</h4>

    <div class="vx-row mb-4">
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
          label-placeholder="اسم الطالب"
          name="first_name"
          data-vv-as="هذا الحقل"
          v-validate="'required|alpha_spaces'"
          v-model="formData.first_name"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('first_name')">{{
          errors.first("first_name")
        }}</span>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
          label-placeholder="اسم الأب"
          name="middle_name"
          data-vv-as="هذا الحقل"
          v-validate="'required|alpha_spaces'"
          v-model="formData.middle_name"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('middle_name')">{{
          errors.first("middle_name")
        }}</span>
      </div>
      <div class="vx-col sm:w-1/3 w-full">
        <vs-input
          label-placeholder="اللقب"
          name="last_name"
          data-vv-as="هذا الحقل"
          v-validate="'required|alpha_spaces'"
          v-model="formData.last_name"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('last_name')">{{
          errors.first("last_name")
        }}</span>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
          label-placeholder="رقم القيد"
          name="std_id"
          data-vv-as="هذا الحقل"
          v-validate="'required|numeric'"
          icon-pack="feather"
          icon="icon-hash"
          icon-no-border
          v-model="formData.std_id"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('std_id')">{{
          errors.first("std_id")
        }}</span>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
          label-placeholder="البريد الالكتروني"
          name="email"
          data-vv-as="الحقل"
          v-validate="'required|email'"
          icon-pack="feather"
          icon="icon-mail"
          icon-no-border
          v-model="formData.email"
          autocomplete="false"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('email')">{{
          errors.first("email")
        }}</span>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <vs-input
          label-placeholder="رقم الهاتف"
          name="phone_number"
          data-vv-as="الحقل"
          icon-pack="feather"
          icon="icon-phone"
          icon-no-border
          v-model="formData.phone_number"
          autocomplete="false"
          class="w-full"
        />

        <span class="text-danger text-sm" v-show="errors.has('phone_number')">
          {{ errors.first("phone_number") }}
        </span>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-4">
        <vs-input
          class="w-full mb-1"
          name="password"
          type="password"
          ref="password"
          label-placeholder="كلمة المرور"
          data-vv-as="كلمة المرور"
          v-model="formData.password"
        />

        <span class="text-danger text-sm" v-show="errors.has('password')">
          {{ errors.first("password") }}
        </span>
        <span
          class="text-danger block text-sm"
          v-show="errors.has('rgx-password')"
        >
          {{ errors.first("rgx-password") }}
        </span>
      </div>
      <div class="vx-col w-full mb-4">
        <vs-input
          class="w-full mb-1"
          name="password_confirmation"
          type="password"
          label-placeholder="تأكيد كلمة المرور"
          data-vv-as="تأكيد كلمة المرور"
          v-validate="'confirmed:password'"
          v-model="formData.password_confirmation"
        />

        <span
          class="text-danger text-sm"
          v-show="errors.has('password_confirmation')"
        >
          {{ errors.first("password_confirmation") }}
        </span>
      </div>
    </div>

    <vs-divider />
    <div class="flex justify-end">
      <vs-button @click="close" class="mx-5" type="flat">رجوع</vs-button>
      <vs-button @click="submitClicked">حفظ</vs-button>
    </div>
  </vs-prompt>
</template>

<script>
import studentsAPI from "@/api/admin/studentsAPI";

export default {
  name: "StudentForm",
  props: {
    data: {
      required: true,
      type: Object
    },
    active: {
      required: true,
      default: false,
      type: Boolean
    }
  },
  watch: {
    active(val) {
      if (!val) return;

      this.intiValues();
      Object.assign(this.formData, this.data);
    }
  },
  data() {
    return {
      apiErrors: {},
      formData: {
        first_name: "",
        middle_name: "",
        last_name: "",
        std_id: "",
        email: "",
        phone_number: null,
        password: "",
        password_confirmation: ""
      }
    };
  },
  methods: {
    submitClicked() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$startLoading();
          if (this.data.std_id) {
            this.update();
          } else {
            this.add();
          }
        }
      });
    },
    add() {
      studentsAPI
        .create(this.formData)
        .then(response => {
          this.formData.id = response.data.id;
          this.formData.status = response.data.user.status;
          this.$emit("submit", Object.assign({}, this.formData));
          this.close();
          this.$notifySuccess(response.successMessage);
        })
        .catch(({ errors }) => {
          Object.keys(errors).forEach(key => {
            this.$validator.errors.add({ field: key, msg: errors[key][0] });
          });
        })
        .finally(() => this.$closeLoading());
    },
    update() {
      studentsAPI
        .update(this.data.std_id, this.formData)
        .then(response => {
          this.$emit("submit", Object.assign({}, this.formData));
          this.close();
          this.$notifySuccess(response.successMessage);
        })
        .catch(({ errors }) => {
          Object.keys(errors).forEach(key => {
            this.$validator.errors.add({ field: key, msg: errors[key][0] });
          });
        })
        .finally(() => this.$closeLoading());
    },
    close() {
      this.$emit("update:active", false);
    },
    intiValues() {
      this.formData = {
        first_name: "",
        middle_name: "",
        last_name: "",
        std_id: "",
        email: "",
        phone_number: null,
        password: "",
        password_confirmation: ""
      };
      this.$validator.reset();
    }
  }
};
</script>
